import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { VIEWING_CLEAR_ANNOTATIONS } from './constants';
import { useCallback } from 'react';

export function clearAnnotations(forCompare) {
  return {
    type: VIEWING_CLEAR_ANNOTATIONS,
    forCompare,
  };
}

export function useClearAnnotations() {
  const dispatch = useDispatch();

  const { annotations } = useSelector(
    (state) => ({
      annotations: state.viewing.annotations,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(clearAnnotations(...args));
    },
    [dispatch],
  );

  return {
    annotations,
    clearAnnotations: boundAction,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case VIEWING_CLEAR_ANNOTATIONS: {
      // If forCompare is undefined, clear both (legacy behavior)
      if (typeof action.forCompare === 'undefined') {
        return {
          ...state,
          annotations: [],
          filteredAnnotations: [],
          annotationsForCompare: [],
          filteredAnnotationsForCompare: [],
        };
      }
      if (action.forCompare) {
        return {
          ...state,
          annotationsForCompare: [],
          filteredAnnotationsForCompare: [],
        };
      }
      return {
        ...state,
        annotations: [],
        filteredAnnotations: [],
      };
    }

    default:
      return state;
  }
}
